import { render, staticRenderFns } from "./CustomComponent.vue?vue&type=template&id=40544a8f&scoped=true&"
import script from "./CustomComponent.vue?vue&type=script&lang=js&"
export * from "./CustomComponent.vue?vue&type=script&lang=js&"
import style0 from "./CustomComponent.vue?vue&type=style&index=0&id=40544a8f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40544a8f",
  null
  
)

export default component.exports